import {useAtom} from 'jotai'

import {merchantDataAtom} from '../store/merchantData'

export const useMerchantData = () => {
  const [merchantData, merchantDataSet] = useAtom(merchantDataAtom)

  return {merchantData, merchantDataSet}
}
